module.exports = __webpack_public_path__ + "img/e_voucher_logo_white_conasi.e080bef9.png";